class BenefitVideoSlider extends HTMLElement {
    constructor() {
        super();
        this.sectionId = this.dataset.id;
        this.flktySlider = this.initSlider();
        this.flktySlider.stopPlayer();
        this.fixHeightToBiggest();
        this.navigationButtons = this.querySelectorAll(`.flickity-button`) ;
        this.setListeners();
    }

    setListeners() {
        let touchstartX = 0;
        let touchstartY = 0;
        let touchendX = 0;
        let touchendY = 0;

        document.querySelector('.key-features__slide-image.has-more-button').addEventListener( 'click', (e) => {
            e.preventDefault();
            this.flktySlider.playPlayer();
            this.flktySlider.next();
        });

        this.flktySlider.on('change', (event) => this.pauseAllVideos(false));
        window.addEventListener('scroll', (event) => this.pauseAllVideos(true), true);

        this.addEventListener('touchstart', function(event) {
            touchstartX = event.changedTouches[0].screenX;
            touchstartY = event.changedTouches[0].screenY;
        }, false);

        this.addEventListener('touchend', function(event) {
            touchendX = event.changedTouches[0].screenX;
            touchendY = event.changedTouches[0].screenY;
            handleGesture(event);
        }, false);

        this.addEventListener('click', (event) => {
            this.handleVideoClick(event)
        })

        const handleGesture = (event) => {
            if (touchendX < touchstartX) {
                this.flktySlider.next();
            }

            if (touchendX > touchstartX) {
                this.flktySlider.previous();
            }

            if (touchendY === touchstartY) {
                this.handleVideoClick(event);
            }
        }
    }

    initSlider() {
        return new Flickity(`#${this.sectionId} .key-features__slider`, {
            prevNextButtons: true,
            pageDots: true,
            cellAlign: 'left',
            autoPlay: 5000,
            draggable: false,
            wrapAround: true,
            continuousAutoPlay: true,
            pauseAutoPlayOnHover: false,
            imagesLoaded: true
        });
    }

    fixHeightToBiggest = () => {
        const elements = document.querySelectorAll('.key-features__text');

        if (window.innerWidth < 1024) {
            let biggestImgHeight = 0;
            elements.forEach((element, index) => {
                const descriptionElement = element.querySelector('.key-features__text-desc');
                element.style.height = 'auto';
                let hadShowClass = false;

                if (!descriptionElement.classList.contains('show')) {
                    descriptionElement.classList.add('show');
                } else {
                    hadShowClass = true;
                }

                const updatedElement = document.querySelectorAll('.key-features__text')[index];

                if (updatedElement.clientHeight > biggestImgHeight) {
                    biggestImgHeight = element.clientHeight;
                }

                if (!hadShowClass) {
                    descriptionElement.classList.remove('show');
                }
            });

            elements.forEach((element) => element.style.height = biggestImgHeight + 'px');
        } else {
            elements.forEach((element) => element.style.height = 'auto');
        }
    }

    isVideoPlaying (video) {
        return !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
    }

    pauseAllVideos (needToCheckScroll = false) {
        const videos = this.querySelectorAll('.key-features__slide-image:not(.gif-video) video')
        videos.forEach((videoElement) => {
            const videoBounding = videoElement.getBoundingClientRect();
            const isVideoVisible = !!(videoBounding.top < window.innerHeight && videoBounding.bottom >= 0);
            const isPlaying = this.isVideoPlaying(videoElement);
            if ((needToCheckScroll && !isVideoVisible && isPlaying)
                || (!needToCheckScroll && isPlaying)) {
                const videoBlock = videoElement.closest('.benefits-video')
                if (videoElement) {
                    videoElement.pause();
                    videoBlock.classList.remove('play');
                }
            }
        })
    }

    handleVideoClick (event) {
        const videoTarget = event.target;
        if (videoTarget.tagName.toLowerCase() === 'video') {
            event.preventDefault();
            const videoBlock = videoTarget.closest('.benefits-video');
            const isPlaying = this.isVideoPlaying(videoTarget);
            if (!isPlaying) {
                videoTarget.play();
                videoBlock.classList.add('play');
                if (this.navigationButtons) {
                    this.navigationButtons.forEach((button) => {
                        button.style.display = 'none';
                    })
                }
            } else {
                videoTarget.pause();
                videoBlock.classList.remove('play');
                if (this.navigationButtons) {
                    this.navigationButtons.forEach((button) => {
                        button.style.display = 'flex';
                    })
                }
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", (event) => {
    if (!customElements.get('benefit-video-slider')) {
        customElements.define('benefit-video-slider', BenefitVideoSlider)
    }
})
